<template>
  <div class="lead-table">
    <!-- 篩選欄 -->
    <div class="filter-bar">
      <div class="filter-left">
        <el-date-picker
          v-model="startDate"
          type="date"
          placeholder="開始日期"
          value-format="yyyy-MM-dd"
          size="small"
          class="filter-item filter-date"
          @change="onFilterChange"
        ></el-date-picker>
        <!-- <span class="date-separator">至</span> -->
        <el-date-picker
          v-model="endDate"
          type="date"
          placeholder="結束日期"
          value-format="yyyy-MM-dd"
          size="small"
          class="filter-item filter-date"
          @change="onFilterChange"
        ></el-date-picker>
        <el-select
          v-model="filterCarModel"
          placeholder="車型篩選"
          clearable
          size="small"
          class="filter-item"
          @change="onFilterChange"
        >
          <el-option label="全部車型" value=""></el-option>
          <!-- <el-option label="V23 (RWD)" value="V23 (RWD)"></el-option> -->
          <el-option v-for="(item, index) in carList" :key="index" :label="item.name" :value="item.name"></el-option>
        </el-select>
        <el-select
          v-model="filterAcId"
          placeholder="活動篩選"
          clearable
          size="small"
          class="filter-item"
          @change="onFilterChange"
        >
          <el-option label="全部活動" value=""></el-option>
          <el-option v-for="item in activityOptions" :key="item.id" :label="item.titleAc" :value="item.id"></el-option>
        </el-select>
        <el-input
          v-model="filterKeyword"
          placeholder="搜尋姓名/電話"
          clearable
          size="small"
          class="filter-item search-input"
          @clear="onFilterChange"
          @keyup.enter.native="onFilterChange"
        >
          <el-button slot="append" icon="el-icon-search" size="small" @click="onFilterChange"></el-button>
        </el-input>

        <el-button size="small" @click="handleDownload" :loading="downloading">下載表格</el-button>
      </div>
    </div>
    <div class="filter-right text-right">
      <span class="total-count">共 {{ total }} 條記錄</span>
    </div>

    <!-- 數據表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      stripe
      border
      style="width: 100%; font-size: 14px"
      :default-sort="{ prop: 'createTime', order: 'descending' }"
      size="small"
    >
      <el-table-column prop="curNumId" label="活動序號" width="90" align="center"></el-table-column>
      <el-table-column v-if="!showDemoColumns" prop="sales" label="銷售" width="100" align="center">
        <!-- <template slot-scope="scope">
            <el-tag :type="scope.row.agreeUsePersonal ? 'success' : 'danger'" size="small">
              {{ scope.row.agreeUsePersonal }}
            </el-tag>
          </template> -->
      </el-table-column>
      <el-table-column prop="title" label="稱呼" width="80" align="center"></el-table-column>
      <el-table-column prop="lastName" label="姓氏" width="100"></el-table-column>
      <el-table-column prop="firstName" label="名字" width="120"></el-table-column>
      <el-table-column prop="phone" label="電話" width="160"></el-table-column>
      <el-table-column prop="email" label="郵箱" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="carModel" label="車型" width="100"></el-table-column>
      <el-table-column
        v-if="showDemoColumns"
        prop="appointmentTime"
        label="預約時間"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        v-if="showDemoColumns"
        prop="attendees"
        label="出席人數"
        width="90"
        align="center"
      ></el-table-column>
      <el-table-column
        v-if="showDemoColumns"
        prop="carPlate"
        label="車牌號碼"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column label="同意直銷" width="100">
        <template slot-scope="scope">
          {{ scope.row.agreeUsePersonal ? 'YES' : 'NO' }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="remark" label="備註" width="150"></el-table-column> -->
      <el-table-column prop="createTime" label="提交時間" width="170" align="center" sortable></el-table-column>
    </el-table>

    <!-- 分頁 -->
    <div class="pagination-bar">
      <el-pagination
        background
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { rtsLeadListApi, exportExcelApi, activityListApi, currentUrlListApi } from '@/Api/requestApi'
import moment from 'moment'

export default {
  name: 'LeadTable',
  props: {
    brand: {
      type: String,
      default: 'icaur',
    },
    autoRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],

      carList: [],

      total: 0,
      pageNum: 1,
      pageSize: 10,
      startDate: '',
      endDate: '',
      filterCarModel: '',
      filterKeyword: '',
      filterAcId: '',
      activityOptions: [],
      specialAcIds: [7],
      downloading: false,
    }
  },
  computed: {
    showDemoColumns() {
      return this.specialAcIds.includes(Number(this.filterAcId))
    },
  },
  watch: {
    async brand() {
      this.pageNum = 1
      this.fetchActivities()
      await this.fetchDefaultActivity()
      this.fetchData()
    },
    autoRefresh(val) {
      if (val) {
        this.fetchData()
      }
    },
  },
  async mounted() {
    this.fetchActivities()
    await this.fetchDefaultActivity()
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          brand: this.brand,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if (this.startDate) {
          params.startDate = this.startDate
        }
        if (this.endDate) {
          params.endDate = this.endDate
        }
        if (this.filterCarModel) {
          params.carModel = this.filterCarModel
        }
        if (this.filterKeyword) {
          params.keyword = this.filterKeyword
        }
        if (this.filterAcId) {
          params.acId = this.filterAcId
        }
        const { data } = await rtsLeadListApi(params)
        if (data.code === 200) {
          this.tableData = data?.data || []
          this.tableData.forEach((row) => {
            row.createTime = moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.total = data?.total || 0
        }
      } catch (err) {
        console.error('獲取留資列表失敗:', err)
      } finally {
        this.loading = false
      }
    },
    onFilterChange() {
      sessionStorage.setItem(`rts_filterAcId_${this.brand}`, String(this.filterAcId || ''))
      this.pageNum = 1
      this.fetchData()
    },
    onPageChange(page) {
      this.pageNum = page
      this.fetchData()
    },
    onPageSizeChange(size) {
      this.pageSize = size
      this.pageNum = 1
      this.fetchData()
    },
    async handleDownload() {
      this.downloading = true
      try {
        const params = {
          brand: this.brand,
          startDate: this.startDate || '',
          endDate: this.endDate || '',
        }
        if (this.filterAcId) {
          params.acId = this.filterAcId
        }
        const response = await exportExcelApi(params)
        const { code, data } = response.data
        if (code === 200 && data) {
          const link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
          this.$message({ message: '下載成功', type: 'success', duration: 1500 })
        } else {
          this.$message({ message: '下載失敗', type: 'error' })
        }
      } catch (err) {
        console.error('下載失敗:', err)
        this.$message({ message: '下載失敗', type: 'error' })
      } finally {
        this.downloading = false
      }
    },
    async fetchActivities() {
      try {
        const { data } = await activityListApi({ brand: this.brand })
        if (data.code === 200) {
          this.activityOptions = data.data || []
        }
      } catch (err) {
        console.error('獲取活動列表失敗:', err)
      }
    },
    async fetchDefaultActivity() {
      const cacheKey = `rts_filterAcId_${this.brand}`
      const cached = sessionStorage.getItem(cacheKey)
      if (cached !== null) {
        this.filterAcId = cached === '' ? '' : Number(cached)
        return
      }
      try {
        const { data } = await currentUrlListApi({ brand: this.brand })
        if (data.code === 200 && data.data && data.data.length > 0) {
          this.filterAcId = data.data[0].curAcId || ''
        } else {
          this.filterAcId = ''
        }
      } catch (err) {
        console.error('獲取默認活動失敗:', err)
        this.filterAcId = ''
      }
      sessionStorage.setItem(cacheKey, String(this.filterAcId || ''))
    },
  },
}
</script>

<style lang="scss" scoped>
.el-table {
  min-height: 500px !important;
  max-height: 100vh !important;
}
::v-deep .el-loading-mask {
  .el-loading-spinner {
    flex-direction: column !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
::v-deep .el-table__body-wrapper .el-table__row td {
  height: 50px;
  line-height: 50px;
}
.lead-table {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.filter-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
}

.filter-item {
  width: 200px;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.filter-date {
  width: 160px;

  @media (max-width: 768px) {
    width: 48.2%;
  }
}

.date-separator {
  font-size: 13px;
  color: #909399;
  flex-shrink: 0;
}

.search-input {
  width: 240px;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.filter-right {
  .total-count {
    font-size: 13px;
    color: #909399;
  }
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;

  ::v-deep .el-pagination {
    white-space: normal;

    .el-pagination__total,
    .el-pagination__sizes,
    .el-pager {
      margin-bottom: 4px;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;

    ::v-deep .el-pagination {
      text-align: center;

      .el-pager li {
        min-width: 28px;
        height: 28px;
        line-height: 28px;
      }
    }
  }
}

::v-deep .el-table th {
  background: #f5f7fa;
  color: #333;
  font-weight: 600;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafbfc;
}

::v-deep .el-table__body tr:hover > td {
  background: #ecf5ff;
}
</style>
